<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import { messages } from '~/store/specialists'

const router = useRouter()
</script>

<template>
  <div class="flex min-h-[50vh] flex-col items-center justify-center">
    <b class="mb-5 text-lg font-medium md:mb-10 md:text-[40px]">
      {{ messages.emptySpecialists }}
    </b>

    <BasicButton
      class="!h-14 !w-[300px] !rounded-2xl !text-base"
      color="green"
      is-small
      title="Найти в каталоге"
      @click="router.go(0)"
    />
  </div>
</template>
